import styled from 'styled-components'
import styles from './ProgramMetricCard.module.scss'
import numeral from 'numeral'
import { Color } from '../FacilityCounts/FacilityCounts'

interface ProgramHeaderCardProps {
  color: Color
  metric: number
  label: string
  icon: JSX.Element
  style?: React.CSSProperties
}

export const ProgramMetricCard = ({
  color,
  metric,
  label,
  icon,
  style = {}
}: ProgramHeaderCardProps) => (
  <div className={styles.metricCard} style={style}>
    <div>
      <MetricCircle
        color={colors.circle[color]}
        style={{ background: colors.circle[color] }}
        iconColor={colors.icon[color]}
        className={styles.metricCircle}
      >
        {icon}
      </MetricCircle>
    </div>
    <div className={styles.cardText}>
      <h4 className={styles.metricTitle}>{numeral(metric).format('0,0')}</h4>
      <MetricLabel className={styles.metricLabel}>{label}</MetricLabel>
    </div>
  </div>
)

const MetricCircle: any = styled.div`
  background: ${(props: any) => props.color};

  & > svg g {
    fill: ${(props: any) => props.iconColor};
  }
`

const MetricLabel = styled.span`
  color: ${props => props.theme.colors.black};
`

export const colors = {
  circle: {
    blue: 'rgba(0,181,225,0.1)',
    green: 'rgba(0,205,135, 0.1)',
    red: 'rgba(239,9,0,0.1)'
  },
  icon: {
    blue: 'rgba(0,181,225,1)',
    green: 'rgba(0,205,135,1)',
    red: 'rgba(239,9,0,1)'
  }
}
